import React, { useEffect, useState } from "react";
import axios from "axios";
const FaEye = require("react-icons/fa").FaEye;

const TableAspirasiSummary = () => {
  const [summary, setSummary] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [selectedAspirasi, setSelectedAspirasi] = useState<any>(null);

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/aspirasi-summary`);
      setSummary(res.data);
    } catch (err) {
      console.error("Gagal fetch aspirasi summary:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!summary) return <p>Tidak ada data</p>;

  return (
    <>
      {/* --- Tables --- */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Top Pejabat */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Pejabat Dengan Aspirasi Terbanyak</h2>
          <table className="w-full border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">No</th>
                <th className="p-2 border">Nama</th>
                <th className="p-2 border">Jabatan</th>
                <th className="p-2 border">Total</th>
              </tr>
            </thead>
            <tbody>
              {summary.top_pejabat?.map((item: any, i: number) => (
                <tr key={i} className="text-center">
                  <td className="p-2 border">{i + 1}</td>
                  <td className="p-2 border">{item.presiden?.nama.length > 10 ? item.presiden?.nama.slice(0, 10) + "..." : item.presiden?.nama}</td>
                  <td className="p-2 border">{item.presiden?.jabatan.length > 10 ? item.presiden?.jabatan.slice(0, 10) + "..." : item.presiden?.jabatan}</td>

                  <td className="p-2 border">{item.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Latest Aspirasi */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Aspirasi Terbaru</h2>
          <table className="w-full border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">No</th>
                <th className="p-2 border">Nama</th>
                <th className="p-2 border">Judul</th>
                <th className="p-2 border">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {summary.latest_aspirasi?.map((item: any, i: number) => (
                <tr key={i} className="text-center">
                  <td className="p-2 border">{i + 1}</td>
                  <td className="p-2 border">{item.nama?.length > 10 ? item.nama?.slice(0, 10) + "..." : item.nama}</td>

                  <td className="p-2 border">{item.judul?.length > 15 ? item.judul?.slice(0, 15) + "..." : item.judul}</td>
                  <td className="p-2 border">
                    <button onClick={() => setSelectedAspirasi(item)} className="text-primary hover:text-yellow-800">
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* --- Modal --- */}
      {selectedAspirasi && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg shadow-lg">
            <div className="mb-3">
              <div>
                Kepada : <span className="font-bold">{selectedAspirasi.presiden?.nama}</span>
              </div>
              <div>
                Jabatan : <span className="font-bold"> {selectedAspirasi.presiden?.jabatan}</span>
              </div>
            </div>
            <h2 className="text-xl font-bold mb-4">{selectedAspirasi.judul}</h2>
            <p className="mb-2">
              <strong>Aspirasi:</strong> {selectedAspirasi.deskripsi}
            </p>
            {selectedAspirasi.balasan && (
              <p className="mb-2 text-green-700">
                <strong>Balasan:</strong> {selectedAspirasi.balasan}
              </p>
            )}
            <div className="mt-4 flex justify-end">
              <button onClick={() => setSelectedAspirasi(null)} className="px-4 py-2 bg-primary text-white rounded hover:bg-yellow-900">
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TableAspirasiSummary;
